import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import ScrollContent from '../../../../molecules/ScrollContent'
import PersonalSpace from '../../../../molecules/PersonalSpace'
import ChatMessage from './ChatMessage'

function ChatMessages ({ messages, onJsxAttachmentClick }) {
  const scrollRef = useRef(null)
  const lastMessage = messages?.at?.(-1)

  useEffect(() => {
    const el = scrollRef.current
    if (el) {
      el.scrollTop = el.scrollHeight
    }
  }, [messages.length, lastMessage?.message])

  return (
    <ScrollContent ref={scrollRef} className='p-md flex-1'>
      <div className='flex flex-col gap-md'>
        {messages.map((message, index) => (
          <ChatMessage
            key={`message-${index}`} message={message}
            onJsxAttachmentClick={onJsxAttachmentClick}
          />
        ))}
      </div>
      <PersonalSpace size={35} />
    </ScrollContent>
  )
}

ChatMessages.propTypes = {
  messages: PropTypes.arrayOf(PropTypes.shape({
    threadId: PropTypes.string,
    threadMessageId: PropTypes.string,
    actor: PropTypes.oneOf(['agent', 'user']),
    message: PropTypes.string,
    data: PropTypes.object,
    isGenerating: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
    generationStatus: PropTypes.string,
    responseId: PropTypes.string
  })).isRequired,
  onJsxAttachmentClick: PropTypes.func.isRequired
}

export default ChatMessages
